import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { HudNav } from "@/components/eclipse/HudNav";
import { Hero } from "@/components/eclipse/Hero";
import { Marquee } from "@/components/eclipse/Marquee";
import { Intel } from "@/components/eclipse/Intel";
import { Arsenal } from "@/components/eclipse/Arsenal";
import { Operations } from "@/components/eclipse/Operations";
import { Access } from "@/components/eclipse/Access";
import { Transmission } from "@/components/eclipse/Transmission";
import { SteamBand } from "@/components/eclipse/SteamBand";
import { Footer } from "@/components/eclipse/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div data-testid="app-root" className="min-h-screen bg-[#0A0E12] font-sans text-[#F8FAFC]">
      <div className="scanlines-overlay" />
      <div className="noise-overlay" />
      <HudNav />
      <main>
        <Hero />
        <Marquee />
        <Intel />
        <Arsenal />
        <Operations />
        <Access />
        <Transmission />
        <SteamBand />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0E12",
            border: "1px solid #1E293B",
            color: "#00D9FF",
            borderRadius: 0,
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: "11px",
            letterSpacing: "0.15em",
          },
        }}
      />
    </div>
  );
}

export default App;
